export const nearest = [
    {
        "attraction": "Baseny termalne",
        "bold": "Montecatini Terme",
        "url": "Montecatini-terme.jpg",
    },
    {
        "attraction": "Muzeum Leonardo da Vinci i przepiękne winnice w okolicach",
        "bold": "Vinci",
        "url": "Vinci.jpg"
    },
    {
        "attraction": "Katedra św. Zenona, Piazza Del Duomo i wyścigi konne",
        "bold": "Pistoia",
        "url": "Pistoia.jpg"
    },
    {
        "attraction": "Park Pinokia",
        "bold": "Collodi",
        "url": "Collodi.jpg"
    },
    {
        "attraction": "Kolejka Funicolare i uroczy ryneczek z włoskimi knajpkami",
        "bold": "Montecatini Alto",
        "url": "Montecatini-alto.jpg"
    },
    {
        "attraction": "Rodzinne miasto kompozytora Giacomo Pucciniego",
        "bold": "Lukka",
        "url": "Lucca.jpg"
    }
];

export const oneDay = [
    {
        "attraction": "Krzywa wieża, Pole Cudów i prześliczne uliczki wzdłuż rzeki",
        "bold": "Piza",
        "url": "Pisa.jpg",
    },
    {
        "attraction": "Degustacje w winnicach rejonu",
        "bold": "Chianti",
        "url": "Chianti.jpg",
    },
    {
        "attraction": "Średniowieczne wieże na rynku",
        "bold": "San Gimignano",
        "url": "San-Gimignano.jpg",
    },
    {
        "attraction": "Katedra Matki Boskiej Kwietnej, Dzwonnica Giotta, Galeria Uffizi i wiele innych atrakcji",
        "bold": "Florencja",
        "url": "Florencja.jpg",
    }
];

export const longer = [
    {
        "attraction": "Nurkowanie, plaże, trekking i piękne widoki",
        "bold": "Elba",
        "url": "Elba.jpg"
    },
    {
        "attraction": "Bardzo bogate zabytki starożytności i średniowiecza — kościoły, bazyliki, Koloseum, pałace, akwedukty, fontanny",
        "bold": "Rzym i Watykan",
        "url": "Rome.jpg"
    },
    {
        "attraction": "Piękne plaże rozłożone w półkolistych zatokach, pełnych białego piasku i przezroczystej wody",
        "bold": "Korsyka",
        "url": "Corsica.jpg"
    },
    {
        "attraction": "7000 warownych wież obserwacyjnych, nurkowanie, kajaki w uroczych zatokach",
        "bold": "Sardynia",
        "url": "Sardynia.jpg"
    }
];
